import type { BetType } from "src/types/domain/BetDetails"

const betValidationRules: Record<BetType, (selectionCount: number) => boolean> = {
  PickWinner: (selectionCount) => selectionCount >= 1,
  StraightForecast: (selectionCount) => selectionCount === 2,
  ReverseForecast: (selectionCount) => selectionCount === 2,
  Tricast: (selectionCount) => selectionCount === 3,
  CombinationTricast: (selectionCount) => selectionCount === 3,
}

export const isValidBetCombo = (betType: BetType, selectionCount: number): boolean => {
  return betValidationRules[betType](selectionCount)
}
